module.exports = __webpack_public_path__ + "img/box.d633bd4a.png";